import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
}

export function formatBytes(bytes: number) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/** "1 post", "3 posts", "1,200 files": the count, grouped for the reader, and the right noun form. */
export function pluralize(n: number, word: string, plural = `${word}s`) {
  return `${n.toLocaleString("en-US")} ${n === 1 ? word : plural}`;
}

/** Character count the way social networks count it (code points). */
export function charCount(text: string) {
  return Array.from(text).length;
}

export async function copyToClipboard(text: string) {
  await navigator.clipboard.writeText(text);
}
